// eslint-disable-next-line no-unused-vars
import axios from 'axios';
import {
    format,
    isMonday,
    isTuesday,
    isWednesday,
    isThursday,
    isFriday,
    isSaturday,
    isWeekend,
    addDays
} from 'date-fns';

import { formatNumber } from 'migration-flos-react';

/**
 *
 * @param {AxiosRequestConfig} requestConfig
 */
export const ajax = (requestConfig) => axios(requestConfig).then((res) => res.data);

export const formatDate = (date) => {
    return format(date, 'dd-MM-yyyy');
};

export const dataBEFormat = (date) => {
    const d = date.split('-');
    const year = d[0] === '*' ? new Date().getFullYear() : d[0];
    return `${d[2]}-${d[1]}-${year}`;
};

export const getOpenTimes = (openTimes) => {
    const x = openTimes.split('-');
    const [startTime, endTime] = [getHour(x[0]), getHour(x[1])];
    let arr = [],
        i,
        j;
    for (i = startTime; i < endTime; i++) {
        for (j = 0; j < 4; j++) {
            arr.push(getFormattedTime(i) + ':' + (j === 0 ? '00' : 15 * j));
        }
    }
    return arr.slice(1, -3);
};

export const getFormattedTime = (time) => {
    if (typeof time === 'string') {
        if (time.length < 2) {
            return `0${time}`;
        }
    } else if (typeof time === 'number') {
        if (time.toString().length < 2) {
            return `0${time}`;
        }
    }
    return time;
};

const getHour = (time) => {
    return time && time.split(':')[0];
};

export const getOpenTime = (contactDate, openTimeObj, defaultVal) => {
    const d = contactDate.split('-');
    const dateObj = new Date(d[2], d[1] - 1, d[0]);
    if (openTimeObj !== null && openTimeObj !== '') {
        let time;
        const { week } = openTimeObj;
        //   const today = new Date(); // why use today ??
        if (isMonday(dateObj)) {
            time = week.monday;
        } else if (isTuesday(dateObj)) {
            time = week.tuesday;
        } else if (isWednesday(dateObj)) {
            time = week.wednesday;
        } else if (isThursday(dateObj)) {
            time = week.thursday;
        } else if (isFriday(dateObj)) {
            time = week.friday;
        } else if (isSaturday(dateObj)) {
            time = week.saturday;
        } else {
            // It must be Sunday then
            time = week.sunday;
        }
        return [defaultVal, ...getOpenTimes(time)];
    }
};

export const capitalizeLabel = (label) => {
    return `${label.charAt(0).toUpperCase()}${label.slice(1)}`;
};

export const getOpenDates = (openTimeObj) => {
    let days = [];
    const holidays = openTimeObj && openTimeObj.holidays;
    const daysRequired = 6;
    for (let i = 0; i <= daysRequired; i++) {
        let day = addDays(new Date(), i);
        if (!isWeekend(day)) {
            const checkDate = format(day, 'MM-dd');
            const checkYear = format(day, 'yyyy');
            let isHoliday =
                holidays && (holidays.includes(`*-${checkDate}`) || holidays.includes(`${checkYear}-${checkDate}`));

            const isoFormat = format(day, 'dd-MM-yyyy');
            //const daFormat = capitalizeLabel(format(day, 'dddd [den] dd. MMMM yyyy', { locale: daLocale }));
            const daFormat = capitalizeLabel(formatDayToDanish(isoFormat));
            if (!isHoliday) {
                days.push({ label: daFormat, value: isoFormat });
            }
        }
    }
    return days;
};

export const formatPrice = (price) => {
    price = +price;
    return formatNumber(price);
};

export const getHolidays = (holidaysArr) => holidaysArr && holidaysArr.map((holiday) => dataBEFormat(holiday));
/**
 * validate the config and log error if it doesn't match assumed values.
 * @param {*} config
 */
export function validateConfig(config, store) {
    function logError(msg) {
        store.dispatch({
            type: 'vlaidate config error',
            meta: {
                logLevel: 'error',
                logMessage: msg
            }
        });
    }

    if (!config) return logError('missing config');
    if (!config.logLevel) logError('missing logLevel in config');
    if (!config.defaultCategory) logError('missing defaultCategory in config');
    if (!config.trackingHandler) logError('missing trackingHandler in config');

    if (!config.endpoints) return logError('missing endpoints in config');
    if (!config.endpoints.resources) logError('missing resource endpoint in config');
    if (!config.endpoints.log) logError('missing logger endpoints in config');
}

export const formatDateToDanish = (date) => {
    const d = date.split('-');
    const fdate = new Date(d[2], d[1] - 1, d[0]).toLocaleDateString('da-DK', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });

    return `den ${fdate}`;
};

export const formatDayToDanish = (date) => {
    const d = date.split('-');
    return new Date(d[2], d[1] - 1, d[0]).toLocaleDateString('da-DK', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};

export const getContactTime = (time, betweenText) => {
    const minsToAdd = 15;
    const minutes = new Date(new Date('1970/01/01 ' + time).getTime() + minsToAdd * 60000).toLocaleTimeString('en-UK', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });
    return `${time} ${betweenText} ${minutes}`;
};

export const getInsuranceTypes = () => ({
    bil: 'bil',
    indbo: 'indbo',
    ulykke: 'ulykke',
    hus: 'hus',
    fritid: 'fritidshus',
    aarsrejse: 'aarsrejse'
});
